"use strict";

import _styled, { default as _styled2 } from "styled-components";
var _class, _FullScreenButton, _templateObject;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Category, ViewAction } from "../../Core/AnalyticEvents/analyticEvents";
import Icon, { StyledIcon } from "../../Styled/Icon";
import withControlledVisibility from "../HOCs/withControlledVisibility";
import { withViewState } from "../Context";
import Styles from "./full_screen_button.scss";
import Button from "../../Styled/Button";
import Branding from "./Branding";

// The button to make the map full screen and hide the workbench.
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let FullScreenButton = observer(_class = (_FullScreenButton = class FullScreenButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false
    };
  }
  toggleFullScreen() {
    var _this$props$viewState;
    this.props.viewState.setIsMapFullScreen(!this.props.viewState.isMapFullScreen);

    // log a GA event
    (_this$props$viewState = this.props.viewState.terria.analytics) === null || _this$props$viewState === void 0 || _this$props$viewState.logEvent(Category.view, this.props.viewState.isMapFullScreen ? ViewAction.exitFullScreen : ViewAction.enterFullScreen);
  }
  renderButtonText() {
    const btnText = this.props.btnText ? this.props.btnText : null;
    if (this.props.viewState.isMapFullScreen) {
      return /*#__PURE__*/_jsx("span", {
        children: btnText
      });
    }
  }
  render() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      className: classNames(Styles.fullScreen, {
        [Styles.minifiedFullscreenBtnWrapper]: this.props.minified,
        [Styles.trainerBarVisible]: this.props.viewState.trainerBarVisible,
        [Styles.fullScreenWrapper]: this.props.viewState.isMapFullScreen && !this.props.minified
      }),
      children: [this.props.minified && /*#__PURE__*/_jsx("label", {
        className: Styles.toggleWorkbench,
        htmlFor: "toggle-workbench",
        children: this.props.btnText
      }), this.props.viewState.isMapFullScreen && !this.props.minified && /*#__PURE__*/_jsx(Branding, {}), /*#__PURE__*/_jsx(_StyledButton, {
        id: "toggle-workbench",
        primary: true,
        textProps: {
          medium: true
        },
        onClick: () => this.toggleFullScreen(),
        "aria-label": this.props.viewState.isMapFullScreen ? t("sui.showWorkbench", {
          count: this.props.viewState.terria.workbench.items.length
        }) : t("sui.hideWorkbench"),
        title: this.props.viewState.isMapFullScreen ? t("sui.showWorkbench", {
          count: this.props.viewState.terria.workbench.items.length
        }) : t("sui.hideWorkbench"),
        renderIcon: () => this.props.viewState.isMapFullScreen ? /*#__PURE__*/_jsx(StyledIcon, {
          styledWidth: "12px",
          light: true,
          glyph: Icon.GLYPHS.right
        }) : /*#__PURE__*/_jsx(_StyledStyledIcon, {
          light: true,
          styledWidth: "12px",
          glyph: Icon.GLYPHS.left
        }),
        $_css: this.props.viewState.isMapFullScreen === false ? "width: 16px;\n            padding: 0px;" : "width: 100%; border-radius: 0;",
        children: this.renderButtonText()
      })]
    });
  }
}, _defineProperty(_FullScreenButton, "propTypes", {
  viewState: PropTypes.object.isRequired,
  btnText: PropTypes.string,
  minified: PropTypes.bool,
  animationDuration: PropTypes.number,
  // Defaults to 1 millisecond.
  t: PropTypes.func.isRequired
}), _FullScreenButton)) || _class;
export default withTranslation()(withViewState(withControlledVisibility(FullScreenButton)));
var _StyledButton = _styled(Button)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n            border-radius: 0 4px 4px 0;\n            ", "\n          "])), p => p.$_css);
var _StyledStyledIcon = _styled2(StyledIcon).withConfig({
  displayName: "FullScreenButton___StyledStyledIcon",
  componentId: "sc-n3axby-0"
})(["margin-right:2px;"]);